'use client';
import React from 'react';

import { useTranslations } from 'next-intl';
import './EventsSliderItem.css';
import { DateTime } from 'luxon';
import { CalendarEvent } from '@wwe-portal/entities/calendar.type';
import Progress from './Progress';
import Image from 'next/image';

function EventsSliderItem({ event }: Readonly<{ event: CalendarEvent }>) {
  const t = useTranslations();
  /**
   * Calculate duration between date now/startDate and event endDate
   * Format: X Days Y Hours Remaining
   */
  const eventDatesDiff =
    event.startDate && event.endDate
      ? DateTime.fromISO(event.endDate).diff(
          DateTime.fromISO(event.startDate),
          'days'
        ).days
      : 0;
  /**
   * Calculate Progress bar percents
   */
  const onGoing = Math.round(eventDatesDiff) > 2;

  let bannerSrc = '/assets/images/default-banner.png';

  if (event?.eventType === 'fb') {
    bannerSrc = event?.isLive
      ? '/assets/images/fan-voting/Banner_BossBattle.webp'
      : '/assets/images/fan-voting/Banner_ScoutMission.webp';
  } else if (event?.banner) {
    bannerSrc = event.banner;
  }

  return (
    <div className="relative h-full w-full">
      <div className="item__img-container relative">
        <Image
          src={bannerSrc}
          alt="Event banner"
          fill
          className="h-full w-full"
        />
      </div>
      {!!onGoing && (
        <span className="item__badge absolute text-xs font-medium">
          {t('ongoing')}
        </span>
      )}
      <div className="item__body flex w-full flex-col">
        <div className="item__body__title flex-grow-1 text-sm font-medium">
          <p className="mb-0 h-[78px]">
            {event.eventType === 'fb' ? 'Faction Boss' : event.name}
          </p>
        </div>
        <div className="events-slider-item__body__description">
          {event.startDate && event.endDate && (
            <Progress startDate={event.startDate} endDate={event.endDate} />
          )}
        </div>
      </div>
    </div>
  );
}

export default EventsSliderItem;
